const validateContactField = (): void => {
  const onlyTextFields = document.querySelectorAll<HTMLInputElement>('.only-text')

  if (onlyTextFields.length) {
    onlyTextFields.forEach((field: HTMLInputElement) => {
      field.addEventListener('input', function (event: Event) {
        const target = event.target as HTMLInputElement
        const invalidChars: RegExp = /[0-9!@#$%^&*()+=._-]+/g
        if (invalidChars.test(target.value)) {
          target.value = target.value.replace(invalidChars, '')
        }
      })
    })
  }
}

export default validateContactField
